import {matchPath} from "react-router-dom-v5-compat";

// A list of React Router path patterns that we don't the Guide experience
// to be rendered on. The order of this list should match the order in
// app-routes.jsx
const BLOCKLISTED_PATHS = [
    // Learn Storm dashboard & campaign pages
    "/teacher/class/__demo__/learnstorm",
    "/teacher/class/:classCode/learnstorm",
    "/learnstorm-campaign/enroll",
    // Mastery Tower
    "/teacher/class/:classCode/mastery-tower",
    // Devadmin pages
    "/devadmin/*",
    // The GuideExtension uses a different UI, so we don't want to _also_ show
    // the popover version.
    "/guide-extension",
    // AI guide onboarding page
    "/profile/:kaid/guide/onboarding/",
    // The Activities page uses a different UI, so we want to block it here and
    // check for permissions directly on the page
    "/profile/me/khanmigo/activities",
    // All standard region and standard mapping pages
    "/regions/*",
    "/standards/*",
    // District Admin pages
    "/districts/*",
    // Grassroots Khanmigo acquisition
    "/khanmigo/checkout",
    "/khanmigo/thank-you",
    // Free-for-teachers enrollment
    "/khanmigo/teacher-tools",
    // Khamigo Tools tab
    "/teacher/khanmigo-tools",
    // Assessments
    "/assessments/*",
];

/**
 * Determines if the Guide Companion widget should be rendered on a given path.
 *
 * @deprecated - we'll be using the WithKhanmigo templates to explicitly provide
 * the Guide experience on specific pages, instead of providing it on all pages
 * and then blocking it on some.
 */
export const deprecatedIsGuideBlocklistedPath = (pathname: string): boolean =>
    BLOCKLISTED_PATHS.some((blocklistedPath) =>
        matchPath(blocklistedPath, pathname),
    );
